import { Heading, Modal, ModalProps, Divider, Text, Button, Span } from '@afterpaytouch/core'
import React, { FunctionComponent, useCallback, ReactNode } from 'react'
import { Trans, useTranslation } from 'next-i18next'
import { useConsumerSizes } from '../../../../utils/responsive'
import styles from '../style.module.css'
import { maskBankAccountNumber } from '../../../../utils/bankAccount'
import { BankAccountDetails } from '@afterpay/types'
import { NewTabLink } from '../../../NewTabLink'
const I18N_NAMESPACE = ['account', 'ach']

interface AuthorizationLinkProps {
  children?: ReactNode
}

const AuthorizationLink: FunctionComponent<AuthorizationLinkProps> = ({ children }) => {
  const { t } = useTranslation(I18N_NAMESPACE)
  return (
    <Span bold underline size='XS'>
      <NewTabLink href={t('common:urls:paymentAuthorization')}>{children}</NewTabLink>
    </Span>
  )
}

export const RelinkModal: FunctionComponent<
  Omit<ModalProps, 'children'> & { onCallback?: (bankAccount?: BankAccountDetails) => void; bankAccount?: BankAccountDetails }
> = ({ onCallback = () => {}, onClose = () => {}, bankAccount, ...props }) => {
  const { t } = useTranslation(I18N_NAMESPACE)
  const { sectionHeadingSize } = useConsumerSizes()
  // @ts-ignore: OPERATION BLEED STOPPER
  const bank = `${bankAccount?.issuingBank} ${maskBankAccountNumber(bankAccount?.numberMask)}`

  const handleClose = useCallback((): void => {
    onClose()
  }, [onClose])

  const handleOnClickContinue = useCallback((): void => {
    handleClose()
    onCallback(bankAccount)
  }, [onCallback])

  return (
    <Modal {...props} onClose={handleClose} onBackdropClick={handleClose} onEscapeKeyDown={handleClose} testNameSpace='relink'>
      <Modal.Header>
        <div className={styles.textCenter}>
          <Heading size={sectionHeadingSize} testNameSpace='modal'>
            {t('account:tab:payment-methods:relinkModal:header')}
          </Heading>
        </div>
      </Modal.Header>
      <Divider kind={'Hairline'} />
      <Modal.Content>
        <Text>
          <Trans i18nKey='account:tab:payment-methods:relinkModal:body' values={{ bank }} />
        </Text>
        <br />
        <Text size='XS'>
          <Trans
            i18nKey='ach:addBankAccount:detail'
            components={{
              strong: <AuthorizationLink />,
            }}
          />
        </Text>
        <br />
        <Button.Primary padding='Fluid' onClick={handleOnClickContinue} testNameSpace='relink-continue'>
          {t('account:tab:payment-methods:relinkModal:cta')}
        </Button.Primary>
      </Modal.Content>
    </Modal>
  )
}
